"use strict";
(self["__LOADABLE_LOADED_CHUNKS__"] = self["__LOADABLE_LOADED_CHUNKS__"] || []).push([[9410],{

/***/ 55988:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);
/* harmony import */ var links__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(94957);
/* harmony import */ var cookie_storage__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9424);
/* harmony import */ var helpers__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(63687);
/* harmony import */ var analytics__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(95812);
/* harmony import */ var modules_subscription__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(36888);
/* harmony import */ var components_dataDisplay__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(53409);








const LogoLink = (props)=>{
    const { className, to: customLink, color } = props;
    const { subscription } = (0,modules_subscription__WEBPACK_IMPORTED_MODULE_2__/* .useSubscription */ .mU)();
    const defaultLink = (subscription === null || subscription === void 0 ? void 0 : subscription.hasNeverSubscribed) === false ? links__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP.subscription.main : cookie_storage__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP.getItem(helpers__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z.cookieNames.logoRedirectUrl) || links__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP.home;
    const to = customLink === undefined ? defaultLink : customLink;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_dataDisplay__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
        className: className,
        to: to,
        color: color,
        onClick: ()=>{
            (0,analytics__WEBPACK_IMPORTED_MODULE_7__/* .track */ .j)("Scentbird logo click");
        }
    });
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (LogoLink);


/***/ }),

/***/ 36609:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* unused harmony export keyToIconNameMap */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(78364);
/* harmony import */ var components_dataDisplay__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(90234);




const keyToIconNameMap = {
    "BESTSELLER": "48/bestseller",
    "CHARITY": "48/charity",
    "CLEAN": "48/clean",
    "LIMITED_EDITION": "48/limited-time",
    "NEW_ARRIVAL": "48/new",
    "SOLD_OUT": "48/out-of-stock"
};
const ProductGraphicLabels = (props)=>{
    let { className, items, limit } = props;
    if (!(items === null || items === void 0 ? void 0 : items.length)) {
        return null;
    }
    if (limit && items.length > limit) {
        items = items.slice(0, limit);
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (0,classnames__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(className, "grid grid-cols-1 gap-16"),
        children: items.map((key)=>Boolean(keyToIconNameMap[key]) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_dataDisplay__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, {
                className: "mx-auto",
                name: keyToIconNameMap[key],
                "aria-label": key
            }, key))
    });
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.memo(ProductGraphicLabels));


/***/ }),

/***/ 28329:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ ProductPrice_ProductPrice)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ../../node_modules/.pnpm/clsx@2.1.0/node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(78364);
// EXTERNAL MODULE: ./local_modules/intl/useIntl.ts
var useIntl = __webpack_require__(2129);
// EXTERNAL MODULE: ./src/helpers/modifiers/formatPrice.ts
var formatPrice = __webpack_require__(23450);
// EXTERNAL MODULE: ./src/components/dataDisplay/Text/Text.tsx + 1 modules
var Text = __webpack_require__(78565);
;// CONCATENATED MODULE: ./src/compositions/ProductPrice/messages.ts
/* harmony default export */ const messages = ({
    old: {
        en: "Price reduced from"
    },
    new: {
        en: "On sale at"
    }
});

;// CONCATENATED MODULE: ./src/compositions/ProductPrice/ProductPrice.tsx







// TODO should we use currencyCode from data? - added on 14.01.2022 by sonatskiy
const ProductPrice = (props)=>{
    var _data_discountPrice, _data_standardPrice;
    const { className, data, formattedData, textStyle = "h8", oldPriceClassName = "font-normal", newPriceClassName = "font-bold", withNbsp = true } = props;
    const intl = (0,useIntl/* default */.Z)();
    const discountPrice = data === null || data === void 0 ? void 0 : (_data_discountPrice = data.discountPrice) === null || _data_discountPrice === void 0 ? void 0 : _data_discountPrice.amount;
    const standardPrice = data === null || data === void 0 ? void 0 : (_data_standardPrice = data.standardPrice) === null || _data_standardPrice === void 0 ? void 0 : _data_standardPrice.amount;
    let finalPrice;
    let oldPrice;
    let oldPriceLabel;
    let newPriceLabel;
    if (formattedData) {
        const { discountPrice, standardPrice } = formattedData;
        finalPrice = discountPrice || standardPrice;
        if (finalPrice !== standardPrice) {
            oldPrice = standardPrice;
            oldPriceLabel = intl.formatMessage(messages.old);
            newPriceLabel = intl.formatMessage(messages.new);
        }
    } else {
        if (typeof discountPrice === "number") {
            // it's formatted as USD, not cents
            finalPrice = (0,formatPrice/* default */.Z)(discountPrice, {
                isCents: false
            });
            if (standardPrice > discountPrice) {
                oldPrice = (0,formatPrice/* default */.Z)(standardPrice, {
                    isCents: false
                });
                oldPriceLabel = intl.formatMessage(messages.old);
                newPriceLabel = intl.formatMessage(messages.new);
            }
        } else if (typeof standardPrice === "number") {
            finalPrice = (0,formatPrice/* default */.Z)(standardPrice, {
                isCents: false
            });
        }
    }
    if (!finalPrice) {
        return null;
    }
    if (oldPrice) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.ZP, {
            className: className,
            style: textStyle,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("s", {
                    className: (0,clsx/* default */.Z)(oldPriceClassName),
                    "aria-label": oldPriceLabel,
                    "data-testid": "oldPrice",
                    children: oldPrice
                }),
                withNbsp && "\xa0",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                    className: (0,clsx/* default */.Z)(newPriceClassName),
                    "aria-label": newPriceLabel,
                    "data-testid": "price",
                    children: finalPrice
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
        className: (0,clsx/* default */.Z)(className, newPriceClassName),
        style: textStyle,
        "data-testid": "price",
        children: finalPrice
    });
};
/* harmony default export */ const ProductPrice_ProductPrice = (/*#__PURE__*/react.memo(ProductPrice));


/***/ }),

/***/ 61835:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(78364);
/* harmony import */ var analytics__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(95812);
/* harmony import */ var intl__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(927);
/* harmony import */ var components_dataDisplay__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(35838);
/* harmony import */ var components_dataDisplay__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(76884);
/* harmony import */ var components_dataDisplay__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(78565);
/* harmony import */ var components_inputs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(30468);
/* harmony import */ var components_navigation__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45881);








const BannerBase = (props)=>{
    const { "data-testid": dataTestId = "banner", bgImage, buttonStyle, buttonTitle, content, logo, logoClassName, onClick, text, textColor, title, titleClassName, titleColor, to, toTab, href, placement = "Desktop navigation menu", trackParams = {}, caption, height = 296, sizes } = props;
    const handleClick = ()=>{
        (0,analytics__WEBPACK_IMPORTED_MODULE_2__/* .track */ .j)("Banner click", {
            placement,
            content,
            link: to,
            action: "link",
            ...trackParams
        });
        if (typeof onClick === "function") {
            onClick();
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_navigation__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        to: to,
        href: href,
        toTab: toTab,
        onClick: handleClick,
        "data-testid": dataTestId,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_dataDisplay__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
            className: "flex flex-col items-start justify-center bg-light-beige p-32",
            imageClassName: "object-left",
            src: bgImage,
            quality: 85,
            sizes: sizes,
            style: {
                height: `${height}rem`
            },
            children: [
                Boolean(logo) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_dataDisplay__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                    className: logoClassName,
                    src: logo,
                    alt: ""
                }),
                Boolean(title) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_dataDisplay__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP, {
                    className: (0,classnames__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)("whitespace-pre-line", titleClassName),
                    style: "h7",
                    color: titleColor,
                    message: title,
                    html: true
                }),
                Boolean(text) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_dataDisplay__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP, {
                    className: "mt-16 whitespace-pre-line",
                    style: "p3",
                    color: textColor,
                    message: text,
                    html: true
                }),
                Boolean(buttonTitle) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_inputs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                    className: "mt-16",
                    title: buttonTitle,
                    size: 48,
                    style: buttonStyle,
                    tabIndex: -1,
                    width: 240
                }),
                Boolean(caption) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("figcaption", {
                    className: "visually-hidden",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(intl__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                        value: caption
                    })
                })
            ]
        })
    });
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (BannerBase);


/***/ }),

/***/ 68937:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ TheEditBanner_TheEditBanner)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ./local_modules/links/index.ts + 4 modules
var links = __webpack_require__(94957);
// EXTERNAL MODULE: ./src/hooks/useAb.ts
var useAb = __webpack_require__(80550);
// EXTERNAL MODULE: ./src/helpers/constants/index.ts + 8 modules
var constants = __webpack_require__(63687);
// EXTERNAL MODULE: ./local_modules/analytics/index.ts
var analytics = __webpack_require__(95812);
// EXTERNAL MODULE: ./src/modules/messages/messages.ts
var messages = __webpack_require__(35000);
// EXTERNAL MODULE: ./src/components/inputs/Button/messages.ts
var Button_messages = __webpack_require__(34212);
// EXTERNAL MODULE: ./src/compositions/banners/BannerBase/BannerBase.tsx
var BannerBase = __webpack_require__(61835);
;// CONCATENATED MODULE: ./src/compositions/banners/TheEditBanner/images/bg.jpg
const bg_namespaceObject = __webpack_require__.p + "images/bg_cbfdf7.jpg";
;// CONCATENATED MODULE: ./src/compositions/banners/TheEditBanner/images/bg-ab.png
const bg_ab_namespaceObject = __webpack_require__.p + "images/bg-ab_02bc8b.png";
;// CONCATENATED MODULE: ./src/compositions/banners/TheEditBanner/messages.ts
/* harmony default export */ const TheEditBanner_messages = ({
    title: {
        en: "Shop the Edit"
    },
    text: {
        en: `
      Immerse yourself in scent<br />
      beyond the bottle with<br />
      candles, body lotions,<br />
      diffusers, and so much more.
    `
    },
    valentinesText: {
        en: "Find your loves among our <br />selection of gift sets, candles, body <br />care products, and more."
    },
    luxeText: {
        en: "From scented candles to body care <br />products, these products are big on <br />luxury, but easy on your wallet."
    }
});

;// CONCATENATED MODULE: ./src/compositions/banners/TheEditBanner/TheEditBanner.tsx












const TheEditBanner = (props)=>{
    const { onClick, "data-testid": dataTestId = "theEditBanner", placement } = props;
    const isTheValentinesEditEnabled = (0,useAb/* default */.Z)(constants/* default */.Z.abTests.theValentinesEdit) === "b";
    const isTheLuxeEditEnabled = (0,useAb/* default */.Z)(constants/* default */.Z.abTests.theLuxeEdit) === "b";
    let bannerBaseProps;
    if (isTheValentinesEditEnabled) {
        bannerBaseProps = {
            title: messages/* default */.Z.theValentinesEdit,
            text: TheEditBanner_messages.valentinesText,
            bgImage: bg_ab_namespaceObject,
            buttonTitle: Button_messages/* default */.Z.shopNow
        };
    } else if (isTheLuxeEditEnabled) {
        bannerBaseProps = {
            title: messages/* default */.Z.theLuxeEdit,
            text: TheEditBanner_messages.luxeText,
            bgImage: bg_ab_namespaceObject,
            buttonTitle: Button_messages/* default */.Z.shopNow
        };
    } else {
        bannerBaseProps = {
            title: TheEditBanner_messages.title,
            text: TheEditBanner_messages.text,
            bgImage: bg_namespaceObject,
            buttonTitle: Button_messages/* default */.Z.learnMore
        };
    }
    (0,react.useEffect)(()=>{
        if (isTheValentinesEditEnabled || isTheLuxeEditEnabled) {
            (0,analytics/* track */.j)("The Edit entry point display");
        }
    }, [
        isTheValentinesEditEnabled,
        isTheLuxeEditEnabled
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BannerBase/* default */.Z, {
        to: links/* default */.ZP.shop.theEdit,
        textColor: "black",
        content: "TheEdit",
        onClick: onClick,
        placement: placement,
        "data-testid": dataTestId,
        ...bannerBaseProps
    });
};
/* harmony default export */ const TheEditBanner_TheEditBanner = (TheEditBanner);


/***/ }),

/***/ 43672:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);
/* harmony import */ var analytics__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(95812);
/* harmony import */ var modals__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(39977);
/* harmony import */ var helpers__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(23450);
/* harmony import */ var components_inputs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(30468);
/* harmony import */ var components_inputs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(34212);






const CandleClubSubscribeButton = (props)=>{
    const { className, title, price, placement, size = 56, style = "primary", width, fullWidth, fullWidthOnMobile, "data-testid": dataTestId = "candleSubscriptionButton" } = props;
    const handleSubscribeClick = ()=>{
        (0,analytics__WEBPACK_IMPORTED_MODULE_2__/* .track */ .j)("Banner click", {
            placement,
            content: "Candle subscription",
            action: "Subscribe"
        });
        (0,modals__WEBPACK_IMPORTED_MODULE_3__/* .openModal */ .h7)("candleSubscriptionConfirmationModal", {
            action: "subscribe"
        });
    };
    const handleMouseOver = ()=>{
        void (0,modals__WEBPACK_IMPORTED_MODULE_3__/* .preloadModal */ .My)("candleSubscriptionConfirmationModal");
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_inputs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        className: className,
        title: title || {
            ...components_inputs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z.subscribeForPrice,
            values: {
                price: (0,helpers__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(price || 2500)
            }
        },
        size: size,
        style: style,
        width: width,
        fullWidth: fullWidth,
        fullWidthOnMobile: fullWidthOnMobile,
        onClick: handleSubscribeClick,
        onMouseOver: handleMouseOver,
        "data-testid": dataTestId
    });
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (CandleClubSubscribeButton);


/***/ }),

/***/ 72725:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": () => (/* binding */ SearchModal_SearchModal)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ../../node_modules/.pnpm/clsx@2.1.0/node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(78364);
// EXTERNAL MODULE: ./src/hooks/useFt.ts
var useFt = __webpack_require__(64667);
// EXTERNAL MODULE: ./local_modules/device/useDevice.ts
var useDevice = __webpack_require__(96934);
// EXTERNAL MODULE: ./src/helpers/constants/index.ts + 8 modules
var constants = __webpack_require__(63687);
// EXTERNAL MODULE: ./src/components/dataDisplay/Text/Text.tsx + 1 modules
var Text = __webpack_require__(78565);
// EXTERNAL MODULE: ./src/components/layout/WidthContainer/WidthContainer.tsx
var WidthContainer = __webpack_require__(59343);
// EXTERNAL MODULE: ./src/components/feedback/PlainModal/PlainModal.tsx + 1 modules
var PlainModal = __webpack_require__(1987);
// EXTERNAL MODULE: ./src/components/inputs/SearchInput/SearchInput.tsx + 1 modules
var SearchInput = __webpack_require__(6867);
// EXTERNAL MODULE: ./src/components/inputs/CloseIconButton/CloseIconButton.tsx + 2 modules
var CloseIconButton = __webpack_require__(80899);
// EXTERNAL MODULE: ./src/compositions/LogoLink/LogoLink.tsx
var LogoLink = __webpack_require__(55988);
// EXTERNAL MODULE: ./local_modules/formular/useForm.ts
var useForm = __webpack_require__(83493);
// EXTERNAL MODULE: ./local_modules/throttle-debounce/debounce.ts
var debounce = __webpack_require__(12196);
// EXTERNAL MODULE: ./local_modules/apollo-client/hooks/useLazyQuery.ts + 1 modules
var useLazyQuery = __webpack_require__(67851);
;// CONCATENATED MODULE: ./src/compositions/modals/SearchModal/util/productSearch.graphql.ts
const ProductSearchDocument = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "ProductSearch"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "input"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "ProductSearchInput"
                            }
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "productSearch"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "input"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "input"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "products"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "FragmentSpread",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "ProductDrift"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "TradingItemBase"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "TradingItem"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "id"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "uid"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "sku"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "section"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "productGroup"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "image"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "inStock"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "type"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "isLimitedEdition"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "volume"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "unit"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "volume"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "prices"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "standardPrice"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "amount"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "amountCents"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "currencyCode"
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "discountPrice"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "amount"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "amountCents"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "currencyCode"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "ProductBase"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "Product"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "id"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "uid"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "url"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "fullName"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "name"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "type"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "brandInfo"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "name"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "image"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "rebrandImage"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "gender"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "theEdit"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "rebrandLabels"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "marketing"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "extra"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "characteristic"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "category"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "typeGroup"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "upchargePrice"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "hasLep"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "hasVariety"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "isSubscribedToStockNotification"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "rating"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "avgRate"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "selectedTradingItem"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "tradingItems"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "items"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "FragmentSpread",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "TradingItemBase"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "shareEmailAgreement"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "alias": {
                                        "kind": "Name",
                                        "value": "exceptMobileBanner"
                                    },
                                    "name": {
                                        "kind": "Name",
                                        "value": "banner"
                                    },
                                    "arguments": [
                                        {
                                            "kind": "Argument",
                                            "name": {
                                                "kind": "Name",
                                                "value": "type"
                                            },
                                            "value": {
                                                "kind": "EnumValue",
                                                "value": "DESKTOP"
                                            }
                                        }
                                    ]
                                },
                                {
                                    "kind": "Field",
                                    "alias": {
                                        "kind": "Name",
                                        "value": "mobileBanner"
                                    },
                                    "name": {
                                        "kind": "Name",
                                        "value": "banner"
                                    },
                                    "arguments": [
                                        {
                                            "kind": "Argument",
                                            "name": {
                                                "kind": "Name",
                                                "value": "type"
                                            },
                                            "value": {
                                                "kind": "EnumValue",
                                                "value": "MOBILE"
                                            }
                                        }
                                    ]
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "title"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "description"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "advantages"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "agreement"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "note"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "ProductDetailed"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "Product"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "FragmentSpread",
                        "name": {
                            "kind": "Name",
                            "value": "ProductBase"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "notes"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "id"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "name"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "image"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "rebrandImage"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "description"
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "TradingItemDrift"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "TradingItem"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "FragmentSpread",
                        "name": {
                            "kind": "Name",
                            "value": "TradingItemBase"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "variety"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "name"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "image"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "description"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "ProductDrift"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "Product"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "FragmentSpread",
                        "name": {
                            "kind": "Name",
                            "value": "ProductDetailed"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "tradingItems"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "items"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "FragmentSpread",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "TradingItemDrift"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "drift"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "name"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "image"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "description"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "starterSet"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "price"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "amount"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "amountCents"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "currencyCode"
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "discountPrice"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "amount"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "amountCents"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "currencyCode"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
// remove fragments duplicates
// @ts-ignore
ProductSearchDocument["definitions"] = [
    ...new Set(ProductSearchDocument.definitions)
];
/* harmony default export */ const productSearch_graphql = (ProductSearchDocument);

;// CONCATENATED MODULE: ./src/compositions/modals/SearchModal/util/useSearchModal.ts





const useSearchModal = ()=>{
    var _data_productSearch;
    const form = (0,useForm/* default */.Z)({
        fields: {
            search: []
        }
    });
    const [executeSearch, { data, isFetching, error }] = (0,useLazyQuery/* default */.Z)(productSearch_graphql);
    (0,react.useEffect)(()=>{
        const handleQueryChange = (0,debounce/* default */.Z)(()=>{
            const { search: query } = form.getValues();
            void executeSearch({
                variables: {
                    input: {
                        query,
                        pagination: {
                            limit: 10,
                            offset: 0
                        }
                    }
                }
            });
        }, 400);
        form.on("change", handleQueryChange);
        return ()=>{
            handleQueryChange.cancel();
            form.off("change", handleQueryChange);
        };
    }, [
        form,
        executeSearch
    ]);
    return {
        form,
        error,
        isFetching,
        query: form.fields.search.state.value,
        products: (data === null || data === void 0 ? void 0 : (_data_productSearch = data.productSearch) === null || _data_productSearch === void 0 ? void 0 : _data_productSearch.products) || []
    };
};

// EXTERNAL MODULE: ./src/modules/user/user/index.tsx + 1 modules
var user = __webpack_require__(40038);
// EXTERNAL MODULE: ./src/modules/subscription/subscriptionAddons/index.ts + 5 modules
var subscriptionAddons = __webpack_require__(88852);
;// CONCATENATED MODULE: ./src/compositions/modals/SearchModal/messages.ts
/* harmony default export */ const messages = ({
    placeholder: {
        en: "Search Scentbird..."
    },
    topRatedTitle: {
        en: "Perfumes that we love"
    },
    notFound: {
        en: "Sorry, we couldn’t find what you were searching for. Try browsing our best sellers..."
    },
    somethingWrong: {
        en: "Something went wrong, please try again later"
    }
});

// EXTERNAL MODULE: ./local_modules/analytics/index.ts
var analytics = __webpack_require__(95812);
// EXTERNAL MODULE: ./src/modules/constructorIO/useCnstrcResultsTrackingDataAttrs.ts
var useCnstrcResultsTrackingDataAttrs = __webpack_require__(11600);
// EXTERNAL MODULE: ./src/components/layout/Grid/Grid.tsx + 1 modules
var Grid = __webpack_require__(19515);
// EXTERNAL MODULE: ./src/compositions/productCards/ProductCardSmall/ProductCardSmall.tsx
var ProductCardSmall = __webpack_require__(88589);
// EXTERNAL MODULE: ./src/compositions/productCards/ProductCardSmallSkeleton/ProductCardSmallSkeleton.tsx
var ProductCardSmallSkeleton = __webpack_require__(80866);
;// CONCATENATED MODULE: ./src/compositions/modals/SearchModal/components/ProductsGrid/ProductsGrid.tsx








const PRODUCT_BUTTON_PROPS = {
    metadata: {
        placement: "Search"
    }
};
const PRODUCTS_SKELETON = new Array(6).fill(null).map((value, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCardSmallSkeleton/* default */.Z, {}, index));
const ProductsGrid = (props)=>{
    const { products, isFetching, className, query, "data-testid": dataTestId } = props;
    const { isMobile } = (0,useDevice/* default */.Z)();
    const columns = isMobile ? "2-center" : "6-center";
    const createOnItemClick = (product)=>{
        return ()=>{
            var _product_rating, _product_tradingItems_items_, _product_tradingItems_items, _product_tradingItems;
            const params = {
                query,
                productBrand: product.brandInfo.name,
                productCategory: product.category,
                productFullName: product.fullName,
                productGender: product.gender,
                productId: product.id,
                rating: (_product_rating = product.rating) === null || _product_rating === void 0 ? void 0 : _product_rating.avgRate
            };
            if ((_product_tradingItems = product.tradingItems) === null || _product_tradingItems === void 0 ? void 0 : (_product_tradingItems_items = _product_tradingItems.items) === null || _product_tradingItems_items === void 0 ? void 0 : (_product_tradingItems_items_ = _product_tradingItems_items[0]) === null || _product_tradingItems_items_ === void 0 ? void 0 : _product_tradingItems_items_.volume) {
                const { volume, unit } = product.tradingItems.items[0].volume;
                params.productVolume = `${volume} ${unit}`;
            }
            (0,analytics/* track */.j)("Search product name click", params);
        };
    };
    // ConstructorIO browse attributes
    const cnstrcAutocompleteTrackingDataAttrs = (0,useCnstrcResultsTrackingDataAttrs/* useCnstrcResultsTrackingDataAttrs */.P)({
        type: "autosuggest",
        count: products === null || products === void 0 ? void 0 : products.length
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
        className: className,
        align: "stretch",
        columns: columns,
        gutter: 16,
        "data-testid": dataTestId,
        dataAttributes: cnstrcAutocompleteTrackingDataAttrs,
        children: isFetching ? PRODUCTS_SKELETON : products.map((product)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP.Cell, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCardSmall/* default */.Z, {
                    data: product,
                    className: "h-full",
                    buttonProps: PRODUCT_BUTTON_PROPS,
                    onProductClick: createOnItemClick(product)
                })
            }, product.id))
    });
};
/* harmony default export */ const ProductsGrid_ProductsGrid = (ProductsGrid);

// EXTERNAL MODULE: ./src/modules/products/useCatalogueId.ts + 2 modules
var useCatalogueId = __webpack_require__(91491);
// EXTERNAL MODULE: ./src/modules/products/useCatalogueProducts.ts + 1 modules
var useCatalogueProducts = __webpack_require__(32029);
;// CONCATENATED MODULE: ./src/compositions/modals/SearchModal/util/useTopRatedProducts.ts

const useTopRatedProducts = (param)=>{
    let { gender } = param;
    const catalogueName = gender === "MALE" ? "colognes" : "perfumes";
    const { catalogueId, isFetching: isFetchingCatalogue } = (0,useCatalogueId/* default */.Z)({
        catalogueName
    });
    const { data, isFetching } = (0,useCatalogueProducts/* default */.Z)({
        variables: {
            id: catalogueId,
            input: {
                limit: 6,
                sort: "RATING_DESC"
            }
        },
        ssr: false,
        skip: !catalogueId
    });
    return {
        isFetching: isFetchingCatalogue || isFetching,
        products: data === null || data === void 0 ? void 0 : data.products
    };
};

// EXTERNAL MODULE: ./src/helpers/modifiers/formatPrice.ts
var formatPrice = __webpack_require__(23450);
// EXTERNAL MODULE: ./src/components/dataDisplay/Image/Image.tsx + 5 modules
var Image = __webpack_require__(76884);
// EXTERNAL MODULE: ./src/components/dataDisplay/BackgroundImage/BackgroundImage.tsx
var BackgroundImage = __webpack_require__(35838);
// EXTERNAL MODULE: ./src/components/layout/WidthContainerCompensator/WidthContainerCompensator.tsx
var WidthContainerCompensator = __webpack_require__(46907);
// EXTERNAL MODULE: ./src/compositions/buttons/CandleClubSubscribeButton/CandleClubSubscribeButton.tsx
var CandleClubSubscribeButton = __webpack_require__(43672);
;// CONCATENATED MODULE: ./src/compositions/banners/CandleSubscribeSmallBanner/messages.ts
/* harmony default export */ const CandleSubscribeSmallBanner_messages = ({
    supTitle: {
        en: "Candle Club"
    },
    title: {
        en: "Treat yourself to a new scented candle every month!"
    },
    text: {
        en: "Subscribe now, and get a luxe, hand-selected candle delivered to your door each month for {price}."
    },
    buttonTitle: {
        en: "Upgrade for just {price}"
    }
});

;// CONCATENATED MODULE: ./src/compositions/banners/CandleSubscribeSmallBanner/images/bg-desktop.jpg
const bg_desktop_namespaceObject = __webpack_require__.p + "images/bg-desktop_a79560.jpg";
;// CONCATENATED MODULE: ./src/compositions/banners/CandleSubscribeSmallBanner/images/bg-desktop.jpg?src-loader

/* harmony default export */ const bg_desktopsrc_loader = ({ src: bg_desktop_namespaceObject, aspect: 1.8919, width: 1120, height: 592 });
;// CONCATENATED MODULE: ./src/compositions/banners/CandleSubscribeSmallBanner/images/bg-mobile.jpg
const bg_mobile_namespaceObject = __webpack_require__.p + "images/bg-mobile_8f143f.jpg";
;// CONCATENATED MODULE: ./src/compositions/banners/CandleSubscribeSmallBanner/images/bg-mobile.jpg?src-loader

/* harmony default export */ const bg_mobilesrc_loader = ({ src: bg_mobile_namespaceObject, aspect: 1.5127, width: 1248, height: 825 });
;// CONCATENATED MODULE: ./src/compositions/banners/CandleSubscribeSmallBanner/CandleSubscribeSmallBanner.tsx











const CandleSubscribeSmallBanner = (props)=>{
    const { className, placement, withMobileCompensator, "data-testid": dataTestId } = props;
    const { isMobile } = (0,useDevice/* default */.Z)();
    const { candleSubscription } = (0,subscriptionAddons/* useCandleSubscription */.pj)();
    const price = (candleSubscription === null || candleSubscription === void 0 ? void 0 : candleSubscription.price) || 2500;
    const priceWithCents = (0,formatPrice/* default */.Z)(price);
    const priceWithoutCents = (0,formatPrice/* default */.Z)(price, {
        removeZeroCents: true
    });
    const content = /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: isMobile ? "bg-black px-40 pb-48 pt-40" : "w-6/12 pb-4 text-left",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                message: CandleSubscribeSmallBanner_messages.supTitle,
                style: "eye2",
                color: "gold-30"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                className: "mt-16",
                message: CandleSubscribeSmallBanner_messages.title,
                style: isMobile ? "h5" : "h7",
                color: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                className: "mt-16",
                message: {
                    ...CandleSubscribeSmallBanner_messages.text,
                    values: {
                        price: priceWithoutCents
                    }
                },
                style: isMobile ? "p1" : "p3",
                color: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CandleClubSubscribeButton/* default */.Z, {
                className: "mt-16",
                title: {
                    ...CandleSubscribeSmallBanner_messages.buttonTitle,
                    values: {
                        price: priceWithCents
                    }
                },
                placement: placement,
                size: isMobile ? 56 : 48,
                style: "gold-30",
                width: 240,
                fullWidth: true,
                "data-testid": "candleSubscriptionBanner"
            })
        ]
    });
    const Wrapper = isMobile && withMobileCompensator ? WidthContainerCompensator/* default */.Z : react.Fragment;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: className,
            "data-testid": dataTestId,
            children: isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                        className: "w-full",
                        src: bg_mobilesrc_loader,
                        sizes: "100vw",
                        alt: ""
                    }),
                    content
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(BackgroundImage/* default */.Z, {
                className: "flex flex-col items-start justify-center bg-black px-32",
                src: bg_desktopsrc_loader,
                sizes: "560px",
                style: {
                    height: "296rem"
                },
                children: content
            })
        })
    });
};
/* harmony default export */ const CandleSubscribeSmallBanner_CandleSubscribeSmallBanner = (CandleSubscribeSmallBanner);

;// CONCATENATED MODULE: ./src/compositions/modals/SearchModal/components/TopRatedProducts/TopRatedProducts.tsx











const TopRatedProducts = (props)=>{
    const { className, title, withBanner } = props;
    const { gender } = (0,user/* useUser */.aF)();
    const { isMobile } = (0,useDevice/* default */.Z)();
    const { products, isFetching: isFetchingProducts } = useTopRatedProducts({
        gender
    });
    const { candleSubscription, isFetching: isCandleSubscriptionFetching } = (0,subscriptionAddons/* useCandleSubscription */.pj)();
    const isFetching = isFetchingProducts || isCandleSubscriptionFetching;
    const isBannerVisible = withBanner && !isFetching && (candleSubscription === null || candleSubscription === void 0 ? void 0 : candleSubscription.isEnabled) && !(candleSubscription === null || candleSubscription === void 0 ? void 0 : candleSubscription.isSelected);
    if (!isFetching && !(products === null || products === void 0 ? void 0 : products.length)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
            className: (0,clsx/* default */.Z)(isMobile ? "mt-20" : "mt-36", {
                "text-center": !isMobile
            }),
            style: "p2",
            message: messages.somethingWrong,
            "data-testid": "somethingWrong"
        });
    }
    if (isBannerVisible) {
        const firstProducts = products.slice(0, 4);
        const secondProducts = products.slice(4);
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                title,
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductsGrid_ProductsGrid, {
                    className: className,
                    query: "",
                    products: firstProducts,
                    "data-testid": "topRatedProducts"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CandleSubscribeSmallBanner_CandleSubscribeSmallBanner, {
                    className: "my-32",
                    placement: "Search"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductsGrid_ProductsGrid, {
                    query: "",
                    products: secondProducts,
                    "data-testid": "topRatedProducts2"
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            title,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductsGrid_ProductsGrid, {
                className: className,
                query: "",
                products: products,
                isFetching: isFetching,
                "data-testid": "topRatedProducts"
            })
        ]
    });
};
/* harmony default export */ const TopRatedProducts_TopRatedProducts = (TopRatedProducts);

// EXTERNAL MODULE: ./src/components/inputs/ActionButton/ActionButton.tsx
var ActionButton = __webpack_require__(49952);
// EXTERNAL MODULE: ./src/hooks/useAb.ts
var useAb = __webpack_require__(80550);
// EXTERNAL MODULE: ./src/modules/brands/useStrapiWSTONavigationData.ts
var useStrapiWSTONavigationData = __webpack_require__(83474);
// EXTERNAL MODULE: ./src/compositions/banners/TheEditBanner/TheEditBanner.tsx + 3 modules
var TheEditBanner = __webpack_require__(68937);
// EXTERNAL MODULE: ./src/compositions/Header/view/Desktop/components/banners/StrapiWSTONavigationBanner/StrapiWSTONavigationBanner.tsx
var StrapiWSTONavigationBanner = __webpack_require__(26458);
// EXTERNAL MODULE: ./local_modules/links/index.ts + 4 modules
var links = __webpack_require__(94957);
// EXTERNAL MODULE: ./src/components/navigation/Href/Href.tsx
var Href = __webpack_require__(45881);
// EXTERNAL MODULE: ./src/components/inputs/Button/Button.tsx + 6 modules
var Button = __webpack_require__(30468);
;// CONCATENATED MODULE: ./src/compositions/modals/SearchModal/components/Banner/components/CleanFragrancesBanner/messages.ts
/* harmony default export */ const CleanFragrancesBanner_messages = ({
    title: {
        en: "The scents you want,\nminus the ingredients\nyou don't"
    },
    text: {
        en: "These clean fragrances are\nintoxicating to the senses, but\nuse completely non-toxic\nformulations."
    },
    buttonTitle: {
        en: "Shop clean scents"
    }
});

;// CONCATENATED MODULE: ./src/compositions/modals/SearchModal/components/Banner/components/CleanFragrancesBanner/images/bg.jpg
const bg_namespaceObject = __webpack_require__.p + "images/bg_98cb64.jpg";
;// CONCATENATED MODULE: ./src/compositions/modals/SearchModal/components/Banner/components/CleanFragrancesBanner/CleanFragrancesBanner.tsx










const TRACK_CLEAN_FRAGRANCES_BANNER_CLICK = ()=>{
    (0,analytics/* track */.j)("Banner click", {
        placement: "Search",
        content: "Clean fragrances",
        link: links/* default */.ZP.clean.perfumes,
        action: "link"
    });
};
const CleanFragrancesBanner = ()=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Href/* default */.Z, {
        to: links/* default */.ZP.clean.perfumes,
        "data-testid": "searchBanner",
        onClick: TRACK_CLEAN_FRAGRANCES_BANNER_CLICK,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(BackgroundImage/* default */.Z, {
            className: (0,clsx/* default */.Z)("bg-gray-70 p-32"),
            imageClassName: "object-left",
            src: bg_namespaceObject,
            sizes: "560px",
            style: {
                height: "296rem"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                    className: "whitespace-pre-line",
                    style: "h7",
                    message: CleanFragrancesBanner_messages.title
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                    className: "mt-16 whitespace-pre-line",
                    style: "p3",
                    color: "white",
                    message: CleanFragrancesBanner_messages.text
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                    className: "mt-16",
                    title: CleanFragrancesBanner_messages.buttonTitle,
                    size: 48,
                    style: "primary",
                    tabIndex: -1,
                    width: 240
                })
            ]
        })
    });
/* harmony default export */ const CleanFragrancesBanner_CleanFragrancesBanner = (CleanFragrancesBanner);

;// CONCATENATED MODULE: ./src/compositions/modals/SearchModal/components/Banner/Banner.tsx









const Banner = ()=>{
    var _strapiWSTONavigationData_banners;
    const isTheEditEnabled = (0,useFt/* default */.Z)(constants/* default */.Z.features.theEdit);
    const strapiWSTONavigationData = (0,useStrapiWSTONavigationData/* default */.Z)();
    const isStrapiWSTONavigationSearchBannerExists = Boolean(strapiWSTONavigationData === null || strapiWSTONavigationData === void 0 ? void 0 : (_strapiWSTONavigationData_banners = strapiWSTONavigationData.banners) === null || _strapiWSTONavigationData_banners === void 0 ? void 0 : _strapiWSTONavigationData_banners.search);
    const isCandleSubscriptionSearchBannerEnabled = (0,useFt/* default */.Z)(constants/* default */.Z.features.candleClubMoreBanners);
    const { candleSubscription, isFetching } = (0,subscriptionAddons/* useCandleSubscription */.pj)({
        skip: isStrapiWSTONavigationSearchBannerExists
    });
    const isTheValentinesEditEnabled = (0,useAb/* default */.Z)(constants/* default */.Z.abTests.theValentinesEdit) === "b";
    const isTheLuxeEditEnabled = (0,useAb/* default */.Z)(constants/* default */.Z.abTests.theLuxeEdit) === "b";
    if (isFetching) {
        return null;
    }
    const isCandleSubscriptionBannerVisible = isCandleSubscriptionSearchBannerEnabled && (candleSubscription === null || candleSubscription === void 0 ? void 0 : candleSubscription.isEnabled) && !candleSubscription.isSelected;
    if (isTheEditEnabled && (isTheValentinesEditEnabled || isTheLuxeEditEnabled)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(TheEditBanner/* default */.Z, {
            placement: "Search",
            "data-testid": "searchBanner"
        });
    }
    if (isStrapiWSTONavigationSearchBannerExists) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(StrapiWSTONavigationBanner/* default */.Z, {
            placement: "search",
            "data-testid": "searchBanner"
        });
    }
    if (isCandleSubscriptionBannerVisible) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(CandleSubscribeSmallBanner_CandleSubscribeSmallBanner, {
            placement: "Search",
            "data-testid": "searchBanner",
            withMobileCompensator: true
        });
    }
    return isTheEditEnabled ? /*#__PURE__*/ (0,jsx_runtime.jsx)(TheEditBanner/* default */.Z, {
        placement: "Search",
        "data-testid": "searchBanner"
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(CleanFragrancesBanner_CleanFragrancesBanner, {});
};
/* harmony default export */ const Banner_Banner = (Banner);

// EXTERNAL MODULE: ./src/modules/messages/messages.ts
var messages_messages = __webpack_require__(35000);
;// CONCATENATED MODULE: ./src/compositions/modals/SearchModal/components/Nav/util/messages.ts
/* harmony default export */ const util_messages = ({
    quiz: {
        title: {
            en: "Let’s get personal"
        },
        actionText: {
            en: "Take our fragrance quiz"
        }
    },
    collections: {
        title: {
            en: "Need some ideas?"
        },
        actionText: {
            en: "Browse our curated collections"
        }
    },
    home: {
        title: {
            en: "Cozy at home"
        },
        actionText: {
            en: "Our latest home fragrances"
        }
    },
    theEdit: {
        title: {
            en: "The Edit"
        },
        actionText: {
            en: "Explore home fragrances"
        }
    }
});

;// CONCATENATED MODULE: ./src/compositions/modals/SearchModal/components/Nav/util/data.ts


const defaultNavItems = [
    {
        ...util_messages.quiz,
        to: links/* default */.ZP.smartRecommendations,
        trackingKey: "Take our fragrance quiz"
    },
    {
        ...util_messages.collections,
        MALE: {
            to: links/* default */.ZP.collectionsMen
        },
        FEMALE: {
            to: links/* default */.ZP.collectionsWomen
        },
        trackingKey: "Browse our curated collections"
    }
];
const bestsellersNavItems = [
    {
        ...util_messages.home,
        MALE: {
            to: links/* default */.ZP.bestsellers.colognes
        },
        FEMALE: {
            to: links/* default */.ZP.bestsellers.perfumes
        },
        trackingKey: "Our latest home fragrances"
    }
];
const theEditNavItems = [
    {
        ...util_messages.theEdit,
        to: links/* default */.ZP.shop.theEdit,
        trackingKey: "The edit"
    }
];

;// CONCATENATED MODULE: ./src/compositions/modals/SearchModal/components/Nav/util/useNav.ts






const useNav = ()=>{
    const isTheEditEnabled = (0,useFt/* default */.Z)(constants/* default */.Z.features.theEdit);
    const isTheValentinesEditEnabled = (0,useAb/* default */.Z)(constants/* default */.Z.abTests.theValentinesEdit) === "b";
    const isTheLuxeEditEnabled = (0,useAb/* default */.Z)(constants/* default */.Z.abTests.theLuxeEdit) === "b";
    (0,react.useEffect)(()=>{
        if (isTheEditEnabled) {
            (0,analytics/* track */.j)("The Edit entry point display");
        }
    }, [
        isTheEditEnabled
    ]);
    return (0,react.useMemo)(()=>{
        let extraNavItems = bestsellersNavItems;
        if (isTheEditEnabled) {
            extraNavItems = [
                ...theEditNavItems
            ];
            if (isTheValentinesEditEnabled) {
                extraNavItems[0].title = messages_messages/* default */.Z.theValentinesEdit;
            } else if (isTheLuxeEditEnabled) {
                extraNavItems[0].title = messages_messages/* default */.Z.theLuxeEdit;
            }
        }
        return [
            ...defaultNavItems,
            ...extraNavItems
        ];
    }, [
        isTheEditEnabled,
        isTheValentinesEditEnabled
    ]);
};
/* harmony default export */ const util_useNav = (useNav);

;// CONCATENATED MODULE: ./src/compositions/modals/SearchModal/components/Nav/Nav.tsx









const Nav = (props)=>{
    const { gender } = (0,user/* useUser */.aF)();
    const { className } = props;
    const navItems = util_useNav();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (0,clsx/* default */.Z)(className, "flex w-full items-start self-center"),
        "data-testid": "nav",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w-6/12 pr-8",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Banner_Banner, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                className: "w-6/12 self-center pl-72",
                children: navItems.map((item, index)=>{
                    const { title, actionText, to, trackingKey } = {
                        ...item,
                        ...item[gender]
                    };
                    const trackLinkClick = ()=>{
                        (0,analytics/* track */.j)("Search explore link click", {
                            content: trackingKey,
                            link: to
                        });
                    };
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                        className: (0,clsx/* default */.Z)("mr-16 w-full", {
                            "mt-48": index
                        }),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                                style: "p1",
                                message: title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ActionButton/* default */.Z, {
                                className: "mt-8",
                                title: actionText,
                                to: to,
                                onClick: trackLinkClick
                            })
                        ]
                    }, to);
                })
            })
        ]
    });
};
/* harmony default export */ const Nav_Nav = (Nav);

;// CONCATENATED MODULE: ./src/compositions/modals/SearchModal/SearchModal.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const SearchModal_module = ({"header":"cILhXK","logo":"d3BJLF","searchInput":"mLE9TE","closeButton":"kpJpJp"});
;// CONCATENATED MODULE: ./src/compositions/modals/SearchModal/SearchModal.tsx















const SearchModal = (props)=>{
    const { name, closeModal } = props;
    const handleCloseButtonClick = ()=>closeModal(true);
    const isCandleClubMoreBannersEnabled = (0,useFt/* default */.Z)(constants/* default */.Z.features.candleClubMoreBanners);
    const { isMobile } = (0,useDevice/* default */.Z)();
    const { form, query, products, isFetching, error } = useSearchModal();
    let content;
    if (error) {
        // TODO: "Server error" UI element
        content = error.message;
    } else if (!query) {
        content = isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)(TopRatedProducts_TopRatedProducts, {
            className: "pt-32",
            withBanner: isCandleClubMoreBannersEnabled,
            title: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                className: "mt-48",
                style: "h5",
                message: messages.topRatedTitle,
                "data-testid": "topRatedLabel"
            })
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav_Nav, {
            className: "mt-36"
        });
    } else if (query.length <= 2 || !isFetching && !(products === null || products === void 0 ? void 0 : products.length)) {
        /* User see "not found" text with default recommendations of the first fragrances from Top Rated Products */ content = /*#__PURE__*/ (0,jsx_runtime.jsx)(TopRatedProducts_TopRatedProducts, {
            className: isMobile ? "pt-24" : "pt-32",
            withBanner: isMobile && isCandleClubMoreBannersEnabled,
            title: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                className: (0,clsx/* default */.Z)(isMobile ? "mt-20" : "mt-36", {
                    "text-center": !isMobile
                }),
                style: "p2",
                message: messages.notFound,
                "data-testid": "notFoundBlock"
            })
        });
    } else {
        content = /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductsGrid_ProductsGrid, {
            className: isMobile ? "pt-32" : "pt-36",
            products: products,
            isFetching: isFetching,
            "data-testid": "searchProducts",
            query: query
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PlainModal/* default */.ZP, {
        type: "fullscreen-top",
        withCloseButton: false,
        underMobileHeader: false,
        closeModal: closeModal,
        "data-testid": name,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(WidthContainer/* default */.Z, {
            className: "w-full",
            ignore: isMobile,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (0,clsx/* default */.Z)(SearchModal_module.header, "relative grid"),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(LogoLink/* default */.Z, {
                            className: SearchModal_module.logo,
                            color: "black"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchInput/* default */.Z, {
                            className: SearchModal_module.searchInput,
                            size: isMobile ? 30 : 34,
                            field: form.fields.search,
                            placeholder: messages.placeholder
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseIconButton/* default */.Z, {
                            className: SearchModal_module.closeButton,
                            onClick: handleCloseButtonClick
                        })
                    ]
                }),
                content
            ]
        })
    });
};
/* harmony default export */ const SearchModal_SearchModal = (SearchModal);


/***/ }),

/***/ 40495:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var helpers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(63687);
/* harmony import */ var hooks__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(64667);


const getCollaboration = (rebrandLabels)=>{
    var _rebrandLabels_extra;
    if (rebrandLabels === null || rebrandLabels === void 0 ? void 0 : (_rebrandLabels_extra = rebrandLabels.extra) === null || _rebrandLabels_extra === void 0 ? void 0 : _rebrandLabels_extra.includes("SAKS_SELECTED")) {
        return "saks";
    }
};
const useProductCollaboration = (param)=>{
    let { labels } = param;
    const isSaksCollaborationEnabled = (0,hooks__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(helpers__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z.features.collaborationSaks);
    const collaboration = getCollaboration(labels);
    if (collaboration === "saks" && isSaksCollaborationEnabled) {
        return collaboration;
    }
    return null;
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (useProductCollaboration);


/***/ }),

/***/ 80073:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ collaborations_useProductCollaborationLabel)
});

// EXTERNAL MODULE: ./src/modules/collaborations/useProductCollaboration.ts
var useProductCollaboration = __webpack_require__(40495);
;// CONCATENATED MODULE: ./src/modules/collaborations/messages.ts
/* harmony default export */ const messages = ({
    default: {
        en: "Scentbird Select"
    }
});

;// CONCATENATED MODULE: ./src/modules/collaborations/useProductCollaborationLabel.ts


const useProductCollaborationLabel = (param)=>{
    let { labels } = param;
    const collaboration = (0,useProductCollaboration/* default */.Z)({
        labels
    });
    if (collaboration === "saks") {
        return messages["default"];
    }
};
/* harmony default export */ const collaborations_useProductCollaborationLabel = (useProductCollaborationLabel);


/***/ }),

/***/ 6161:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   z: () => (/* binding */ useCnstrcProductTrackingDataAttrs)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52983);
/* harmony import */ var helpers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23450);


const useCnstrcProductTrackingDataAttrs = (param)=>{
    let { id, name, prices, variationId } = param;
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>{
        const { standardPrice, discountPrice } = prices || {};
        const price = (discountPrice === null || discountPrice === void 0 ? void 0 : discountPrice.amountCents) || (standardPrice === null || standardPrice === void 0 ? void 0 : standardPrice.amountCents);
        const formattedPrice = price && (0,helpers__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(price, {
            withCurrency: false
        });
        return {
            "data-cnstrc-item-id": id,
            "data-cnstrc-item-name": name,
            "data-cnstrc-item-price": formattedPrice,
            "data-cnstrc-item-variation-id": variationId
        };
    }, [
        id,
        name,
        prices,
        variationId
    ]);
};


/***/ }),

/***/ 11600:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   P: () => (/* binding */ useCnstrcResultsTrackingDataAttrs)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52983);

const useCnstrcResultsTrackingDataAttrs = (params)=>{
    const { type, count = 0, filterName, filterValue } = params;
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>{
        const baseAttrs = {
            [`data-cnstrc-${type}`]: true
        };
        if (!Number.isNaN(count)) {
            baseAttrs["data-cnstrc-num-results"] = count;
        }
        if (type === "autosuggest") {
            baseAttrs["data-cnstrc-item-section"] = "Search Suggestions";
        }
        if (type === "search" || type === "browse") {
            baseAttrs["data-cnstrc-filter-name"] = filterName ?? "";
            baseAttrs["data-cnstrc-filter-value"] = filterValue ?? "";
        }
        return baseAttrs;
    }, [
        type,
        count,
        filterName,
        filterValue
    ]);
};


/***/ }),

/***/ 35000:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
    theValentinesEdit: {
        en: `The Valentine's Edit`
    },
    theLuxeEdit: {
        en: "The Luxe Edit"
    }
});


/***/ }),

/***/ 26676:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ strapi_getRichTextStateFromMessage)
});

// EXTERNAL MODULE: ./local_modules/logger/index.ts
var logger = __webpack_require__(53297);
;// CONCATENATED MODULE: ./src/modules/strapi/isRichTextStateEmpty.ts
const getRichTextStateFromMessage = (richTextState)=>{
    var _richTextState_root_children, _richTextState_root, _richTextState_root_children1, _richTextState_root1;
    return (richTextState === null || richTextState === void 0 ? void 0 : (_richTextState_root = richTextState.root) === null || _richTextState_root === void 0 ? void 0 : (_richTextState_root_children = _richTextState_root.children) === null || _richTextState_root_children === void 0 ? void 0 : _richTextState_root_children.length) === 0 || (richTextState === null || richTextState === void 0 ? void 0 : (_richTextState_root1 = richTextState.root) === null || _richTextState_root1 === void 0 ? void 0 : (_richTextState_root_children1 = _richTextState_root1.children) === null || _richTextState_root_children1 === void 0 ? void 0 : _richTextState_root_children1.some((node)=>{
        var _node_children;
        return (node === null || node === void 0 ? void 0 : (_node_children = node.children) === null || _node_children === void 0 ? void 0 : _node_children.length) !== 0;
    })) === false;
};
/* harmony default export */ const isRichTextStateEmpty = (getRichTextStateFromMessage);

;// CONCATENATED MODULE: ./src/modules/strapi/getRichTextStateFromMessage.ts


const getRichTextStateFromMessage_getRichTextStateFromMessage = (state)=>{
    if (!state) {
        return null;
    }
    try {
        const editorState = JSON.parse(state);
        const isEditorStateEmpty = isRichTextStateEmpty(editorState);
        return !isEditorStateEmpty ? editorState : null;
    } catch (error) {
        logger/* default */.Z.error(error);
        return null;
    }
};
/* harmony default export */ const strapi_getRichTextStateFromMessage = (getRichTextStateFromMessage_getRichTextStateFromMessage);


/***/ })

}]);